/**
 * The saved card has no column for an air waybill's weight, so it travels in
 * `size_type` next to the piece count, in the same JSON array the cabinet and
 * the back office's own importer write: `["3 pcs","120 kg"]`. Cards saved
 * before that, or by another writer, may hold anything - a value that does not
 * parse is simply absent rather than an error.
 */
export const formatAirCargo = ({ pieces, weight }: { pieces: number | null; weight: number | null }): string | null => {
  const parts = [pieces ? `${pieces} pcs` : null, weight ? `${weight} kg` : null].filter(
    (part): part is string => part !== null
  );

  return parts.length === 0 ? null : JSON.stringify(parts);
};

export const parseAirCargo = (sizeType: string | null): { pieces: number | null; weight: number | null } => {
  const empty = { pieces: null, weight: null };

  if (!sizeType) return empty;

  let parsed: unknown;

  try {
    parsed = JSON.parse(sizeType);
  } catch {
    return empty;
  }

  if (!Array.isArray(parsed)) return empty;

  const valueOf = (unit: string): number | null => {
    const entry = parsed.find((part): part is string => typeof part === "string" && part.trim().endsWith(unit));
    if (!entry) return null;

    const value = Number.parseFloat(entry);
    return Number.isFinite(value) ? value : null;
  };

  return { pieces: valueOf("pcs"), weight: valueOf("kg") };
};
